import styled from 'styled-components'

export const TextContainer = styled.p`
    display: -webkit-box;
    line-height: 12px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 9px;
    font-family: ${({ theme }) => theme['font-regular']};

    color: ${({ theme }) => theme['gray-1000']};
    margin: 0;
`

export const BarrierContainer = styled.g`
    .delete-barrier-button {
        display: none;
    }

    .delete-barrier-button.active {
        display: unset;
    }

    :hover {
        .delete-barrier-button {
            display: unset;
        }
    }
`
